import { Dialog } from '@angular/cdk/dialog';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  Output,
  signal,
} from '@angular/core';
import { SHARED_MODULES } from '@app/shared';
import { Checker, notNull } from '@app/shared/utils';
import { AppSelectors } from '@app/store';
import { AppState } from '@app/store/app.state';
import { Store } from '@ngrx/store';
import { BehaviorSubject, map, Observable, take } from 'rxjs';
import { ModalAnswerComponent } from '../modal-answer/modal-answer.component';
import { answerStatus, AnswerStatus } from '../../utils/activity';
import { ModalReviewComponent } from '../modal-review/modal-review.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-summary-upload',
  imports: [SHARED_MODULES],
  templateUrl: './summary-upload.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SummaryUploadComponent {
  @Output() public refresh = new EventEmitter();
  public isTeacher$: Observable<boolean>;
  public data$ = new BehaviorSubject(undefined);
  private readonly dialog = inject(Dialog);
  private readonly _store = inject(Store<AppState>);
  private readonly _destroyRef = inject(DestroyRef);

  constructor() {
    this.isTeacher$ = this._store.select(AppSelectors.DefaultFunction).pipe(map(Checker.isEmployee));
  }

  @Input('data')
  public set setData(value) {
    this.data$.next(value);
  }

  public onOpenReview(data: any) {
    this.dialog.open(ModalReviewComponent, {
      data: { activity: data?.activity },
    });
  }

  public onOpenAnswers(status: AnswerStatus) {
    this.dialog
      .open(ModalAnswerComponent, {
        data: {
          activityId: this.data$.value?.activity?.id,
          dropzone: this.isSend(status),
        },
      })
      .closed.pipe(takeUntilDestroyed(this._destroyRef), take(1), notNull())
      .subscribe(() => this.refresh.emit(true));
  }

  public answerStatus(): any {
    return answerStatus(this.data$.value?.activity);
  }

  public isSend(status: AnswerStatus): boolean {
    return status === AnswerStatus.Send;
  }

  public isLate(status: AnswerStatus): boolean {
    return status === AnswerStatus.Late;
  }

  public isCompleted(status: AnswerStatus): boolean {
    return status === AnswerStatus.Completed;
  }

  public isWaiting(status: AnswerStatus): boolean {
    return status === AnswerStatus.Waiting;
  }

  public isEvaluated(status: AnswerStatus): boolean {
    return status === AnswerStatus.Evaluated;
  }

  public iconStatus(status: AnswerStatus): string {
    if (this.isWaiting(status)) {
      return '/assets/icons/icon-clock.svg';
    }
    if (this.isCompleted(status)) {
      return '/assets/icons/icon-view.svg';
    }
    if (this.isEvaluated(status)) {
      return '/assets/icons/icon-complete.svg';
    }
    return '/assets/icons/icon-upload-fine.svg';
  }
}
